export function calculateBreakpointWidth(rem: number) {
  const dialogWidth = remToPixel(rem)
  const dialogMargins = dialogWidth * 0.1 // the 10 % are the margins left and right
  const width = dialogWidth + dialogMargins - 1 // - 1 because otherwise the dialoge jumps 1 pixel in the width when it reaches the breakpoint

  return width + 'px'
}

function remToPixel(rem: number) {
  // First get root font-size because rem is calculated from the html tag.
  // Then transform the font-size into a number.
  const htmlTag = document.documentElement
  const htmlFontSize = parseInt(
    window.getComputedStyle(htmlTag).getPropertyValue('font-size'),
  )

  return rem * htmlFontSize
}
